export default __webpack_public_path__ + "static/media/undraw-calendar.d4676eeb.svg";